import { useState } from "react";
import { useHistory } from "react-router-dom";
import SpeedSelect from "react-speedselect";
import SuperSpectrum from "super-spectrum";
import ClickOutsideListner from "components/ClickOutsideListner";
import { STENO_FONT_FAMILY_OPTS } from "../constants";
import "./StenoEditorToolbar.scss";

export default function StenoEditorToolbar({
  fnRef,
  handleAlignment,
  handleFontSize,
  fontSize,
  handleFontFamily,
  fontFamily,
}) {
  const history = useHistory();
  const [showColorPicker, setShowColorPicker] = useState(false);
  return (
    <>
      <div className="editor-tools">
        <div className="tools-wrapper">
          <button disabled>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="10"
              fill="none"
            >
              <path
                fill="#B1B2B3"
                d="M6.934 3.066a.714.714 0 1 0-1.01 1.01l1.638 1.638H1.429V1.429h7.143a.715.715 0 0 0 0-1.43H1.429A1.429 1.429 0 0 0 0 1.43v4.285a1.429 1.429 0 0 0 1.429 1.429h6.133L5.924 8.78a.714.714 0 0 0 1.01 1.01l2.857-2.857a.714.714 0 0 0 0-1.01L6.934 3.066Z"
              />
            </svg>
          </button>
          <button disabled>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="10"
              fill="none"
            >
              <path
                fill="#B1B2B3"
                d="M8.573 0H1.43a.715.715 0 0 0 0 1.429h7.143v4.285H2.44l1.638-1.638a.714.714 0 0 0-1.01-1.01L.21 5.924a.714.714 0 0 0 0 1.01L3.067 9.79a.714.714 0 0 0 1.01-1.01L2.44 7.143h6.133A1.429 1.429 0 0 0 10 5.713V1.43a1.429 1.429 0 0 0-1.428-1.43Z"
              />
            </svg>
          </button>
          <div className="separator"></div>
          <div className="react-speedselect-option">
            <SpeedSelect
              options={STENO_FONT_FAMILY_OPTS}
              displayKey="name"
              uniqueKey="value"
              disableSearch={true}
              selectedOption={STENO_FONT_FAMILY_OPTS.find(
                (option) => option.value === fontFamily,
              )}
              onSelect={(option) => handleFontFamily(option.value)}
              disable={true}
            />
          </div>
          <div className="font-size-tool">
            <button onClick={() => handleFontSize(fontSize - 1)} disabled>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="2"
                fill="none"
              >
                <path fill="#8B8B8B" d="M.5.402h9v1.197h-9z" />
              </svg>
            </button>
            <span className="disabled">{fontSize}</span>
            <button onClick={() => handleFontSize(fontSize + 1)} disabled>
              <svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.60049 9.50049H4.40049V5.60049H0.500488V4.40049H4.40049V0.500488H5.60049V4.40049H9.50049V5.60049H5.60049V9.50049Z"
                  fill="#8B8B8B"
                />
              </svg>
            </button>
          </div>
          <button
            className="font-color-tool"
            onClick={() => setShowColorPicker(true)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="8"
              height="9"
              fill="none"
            >
              <path
                fill="#8B8B8B"
                d="M.696 8.186a.75.75 0 0 0 .99-.38L2.488 6h3.026l.802 1.805a.75.75 0 1 0 1.37-.61l-.994-2.237L4.686.446a.75.75 0 0 0-1.371 0L1.309 4.959.315 7.196a.75.75 0 0 0 .38.99ZM4 2.597 4.846 4.5H3.154L4 2.597Z"
              />
            </svg>
            <div className="color-indicator"></div>
          </button>
          <div className="separator"></div>
          <button onClick={(e) => fnRef.current.toggleStyle(e, "bold")}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="12"
              fill="none"
            >
              <path
                fill="#B1B2B3"
                d="M1 0h4.5a3.5 3.5 0 0 1 0 7H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1Zm4.5 5a1.5 1.5 0 0 0 0-3H2v3h3.5Z"
              />
              <path
                fill="#B1B2B3"
                d="M1 5h5.5a3.5 3.5 0 0 1 0 7H1a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm5.5 5a1.5 1.5 0 0 0 0-3H2v3h4.5Z"
              />
            </svg>
          </button>
          <button onClick={(e) => fnRef.current.toggleStyle(e, "italic")}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="11"
              height="12"
              fill="none"
            >
              <path
                fill="#B1B2B3"
                d="M4.568 0h5.502l-.652 1.715H7.584l-3.263 8.57h1.834l-.652 1.716H0l.653-1.715h1.834L5.75 1.715H3.916L4.568 0Z"
              />
            </svg>
          </button>
          <button
            onClick={(e) => fnRef.current.handleTextDecoration(e, "underline")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="12"
              fill="none"
            >
              <path
                fill="#B1B2B3"
                d="M4.737 9.333a4 4 0 0 0 4-4V0H7.07v5.333a2.334 2.334 0 1 1-4.667 0V0H.737v5.333a4 4 0 0 0 4 4ZM.07 10.668V12h9.333v-1.333H.07Z"
              />
            </svg>
          </button>
          <button
            onClick={(e) => fnRef.current.handleTextDecoration(e, "strike")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="12"
              fill="none"
            >
              <path
                fill="#B1B2B3"
                d="M14.883 5.382h-6.23a27.45 27.45 0 0 0-.516-.098c-.26-.047-.362-.067-.502-.095-.837-.163-1.34-.326-1.742-.557-.572-.335-.851-.788-.851-1.388 0-.603.248-1.104.718-1.451.463-.343 1.121-.524 1.904-.524.894 0 1.584.235 2.052.698.238.235.412.523.518.858.021.067.046.163.07.29a.165.165 0 0 0 .162.134h1.187a.165.165 0 0 0 .164-.165v-.016a3.082 3.082 0 0 0-1.006-2.06C10.087.348 9.022 0 7.734 0c-1.179 0-2.24.296-2.989.83-.417.3-.74.672-.955 1.104-.22.442-.331.953-.331 1.515 0 .481.093.889.282 1.248.135.256.32.48.556.685H.533a.13.13 0 0 0-.13.13v.979c0 .071.059.13.13.13h7.064c.035.006.064.013.096.02.504.1.808.17 1.087.247.375.106.662.217.9.351.583.33.869.802.869 1.451 0 .576-.253 1.09-.711 1.448-.498.39-1.233.594-2.128.594-.713 0-1.316-.139-1.797-.408a2.074 2.074 0 0 1-1.018-1.28.167.167 0 0 0-.158-.122h-1.3a.165.165 0 0 0-.164.164v.017c.003.037.006.068.01.093.106.796.494 1.448 1.152 1.937.768.567 1.85.868 3.128.868 1.373 0 2.524-.323 3.33-.935.407-.308.72-.688.93-1.125.213-.442.322-.944.322-1.492 0-.519-.094-.952-.29-1.327a2.24 2.24 0 0 0-.356-.503h3.384a.13.13 0 0 0 .13-.13V5.51a.13.13 0 0 0-.13-.128Z"
              />
            </svg>
          </button>
          <div className="separator"></div>
          <button onClick={() => handleAlignment("left")} disabled>
            <svg
              width="13"
              height="12"
              viewBox="0 0 13 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.01367 8.00049H0.0136719V9.33349H8.01367V8.00049ZM8.01367 2.66749H0.0136719V4.00049H8.01367V2.66749ZM0.0136719 6.66749H12.0137V5.33349H0.0136719V6.66749ZM0.0136719 12.0005H12.0137V10.6675H0.0136719V12.0005ZM0.0136719 0.000488281V1.33349H12.0137V0.000488281H0.0136719Z"
                fill="#B1B2B3"
              />
            </svg>
          </button>
          <button onClick={() => handleAlignment("center")} disabled>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="12"
              fill="none"
            >
              <path
                fill="#B1B2B3"
                d="M2.68 8v1.333h6.668V8H2.68ZM.015 12h12v-1.332h-12V12Zm0-5.333h12V5.333h-12v1.334Zm2.667-4V4h6.667V2.667H2.68ZM.014 0v1.333h12V0h-12Z"
              />
            </svg>
          </button>
          <button onClick={() => handleAlignment("right")} disabled>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="12"
              fill="none"
            >
              <path
                fill="#B1B2B3"
                d="M.014 12h12v-1.332h-12V12Zm4-2.667h8V8h-8v1.333Zm-4-2.667h12V5.333h-12v1.333Zm4-2.666h8V2.667h-8V4Zm-4-4v1.333h12V0h-12Z"
              />
            </svg>
          </button>
          <button onClick={() => handleAlignment("justify")} disabled>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="12"
              fill="none"
            >
              <path
                fill="#B1B2B3"
                d="M.014 12h12v-1.332h-12V12Zm0-2.667h12V8h-12v1.333Zm0-2.667h12V5.333h-12v1.333ZM.014 4h12V2.667h-12V4Zm0-4v1.333h12V0h-12Z"
              />
            </svg>
          </button>
          <div className="separator"></div>
          <button onClick={(e) => fnRef.current.toggleList(e, "ol")}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="12"
              fill="none"
            >
              <path
                fill="#B1B2B3"
                fillRule="evenodd"
                d="M4.014.667h7.666a.667.667 0 1 1 0 1.333H4.014a.667.667 0 0 1 0-1.333Zm0 4.667h7.666a.667.667 0 1 1 0 1.333H4.014a.667.667 0 1 1 0-1.333Zm0 4.667h7.666a.666.666 0 1 1 0 1.333H4.014a.667.667 0 1 1 0-1.333ZM.347.667a.333.333 0 0 1 0-.667h.667a.33.33 0 0 1 .333.334v2a.333.333 0 1 1-.667 0V.677L.347.667Zm0 4H1.68A.33.33 0 0 1 2.014 5v.334L.88 6.667h.8A.33.33 0 0 1 2.014 7c0 .187-.15.334-.334.334H.347A.33.33 0 0 1 .014 7v-.333l1.133-1.333h-.8A.33.33 0 0 1 .014 5c0-.186.132-.333.333-.333Zm1.333 7.334H.347a.333.333 0 1 1 0-.667h1V11h-1a.333.333 0 1 1 0-.667h1V10h-1a.333.333 0 0 1 0-.667H1.68a.333.333 0 0 1 .334.333v2a.333.333 0 0 1-.334.334Z"
                clipRule="evenodd"
              />
            </svg>
          </button>
          <button onClick={(e) => fnRef.current.toggleList(e, "ul")}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="12"
              fill="none"
            >
              <path
                fill="#B1B2B3"
                fillRule="evenodd"
                d="M3.861.667h7.667a.667.667 0 1 1 0 1.333H3.86a.667.667 0 0 1 0-1.333Zm0 4.667h7.667a.667.667 0 1 1 0 1.333H3.86a.667.667 0 1 1 0-1.333Zm0 4.666h7.667a.667.667 0 0 1 0 1.334H3.86a.667.667 0 0 1 0-1.334Z"
                clipRule="evenodd"
              />
              <path
                fill="#B1B2B3"
                d="M.347 5.34h1.33v1.33H.347zM.347.69h1.33v1.33H.347zM.347 10.001h1.33v1.33H.347z"
              />
            </svg>
          </button>
          <div className="separator"></div>
          <button onClick={(e) => fnRef.current.showDialogueBoxAtCursor(e)}>
            <svg
              width="13"
              height="14"
              viewBox="0 0 13 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.12262 2.86615L7.21637 1.7724C7.50076 1.488 7.83839 1.26241 8.20996 1.1085C8.58154 0.954584 8.9798 0.875366 9.38199 0.875366C9.78419 0.875366 10.1824 0.954584 10.554 1.1085C10.9256 1.26241 11.2632 1.488 11.5476 1.7724C11.832 2.05679 12.0576 2.39442 12.2115 2.76599C12.3654 3.13757 12.4446 3.53583 12.4446 3.93802C12.4446 4.34022 12.3654 4.73847 12.2115 5.11005C12.0576 5.48163 11.832 5.81925 11.5476 6.10365L9.36012 8.29115C9.07573 8.57556 8.73811 8.80117 8.36653 8.95509C7.99495 9.10902 7.59669 9.18824 7.19449 9.18824C6.79229 9.18824 6.39403 9.10902 6.02245 8.95509C5.65087 8.80117 5.31325 8.57556 5.02887 8.29115C4.91301 8.16667 4.84992 8.00212 4.85286 7.8321C4.85579 7.66207 4.92453 7.4998 5.04462 7.3794C5.16502 7.25931 5.32729 7.19057 5.49732 7.18764C5.66734 7.1847 5.83189 7.24779 5.95637 7.36365C6.11878 7.52657 6.31174 7.65583 6.52421 7.74403C6.73667 7.83223 6.96445 7.87763 7.19449 7.87763C7.42453 7.87763 7.65231 7.83223 7.86478 7.74403C8.07724 7.65583 8.27021 7.52657 8.43262 7.36365L10.6201 5.17615C10.9325 4.84457 11.1034 4.40433 11.0967 3.94882C11.0899 3.49331 10.9059 3.05836 10.5838 2.73623C10.2617 2.4141 9.8267 2.23014 9.37119 2.22335C8.91568 2.21657 8.47545 2.3875 8.14387 2.6999L7.05012 3.79365C6.92564 3.90951 6.76109 3.9726 6.59107 3.96966C6.42104 3.96672 6.25877 3.89799 6.13837 3.7779C6.01828 3.65749 5.94954 3.49523 5.94661 3.3252C5.94367 3.15517 6.00676 2.99063 6.12262 2.86615ZM2.01887 11.3011C2.18128 11.4641 2.37424 11.5933 2.58671 11.6815C2.79917 11.7697 3.02695 11.8151 3.25699 11.8151C3.48703 11.8151 3.71481 11.7697 3.92728 11.6815C4.13974 11.5933 4.33271 11.4641 4.49512 11.3011L5.58887 10.2074C5.71335 10.0915 5.87789 10.0284 6.04792 10.0314C6.21795 10.0343 6.38021 10.1031 6.50062 10.2231C6.6207 10.3435 6.68944 10.5058 6.69238 10.6758C6.69531 10.8459 6.63223 11.0104 6.51637 11.1349L5.42262 12.2286C5.13822 12.513 4.8006 12.7386 4.42902 12.8925C4.05744 13.0465 3.65919 13.1257 3.25699 13.1257C2.44473 13.1257 1.66573 12.803 1.09137 12.2286C0.517008 11.6543 0.194336 10.8753 0.194336 10.063C0.194336 9.25076 0.517008 8.47176 1.09137 7.8974L3.27887 5.7099C3.56325 5.42549 3.90087 5.19988 4.27245 5.04595C4.64403 4.89203 5.04229 4.8128 5.44449 4.8128C5.84669 4.8128 6.24495 4.89203 6.61653 5.04595C6.98811 5.19988 7.32573 5.42549 7.61012 5.7099C7.72598 5.83438 7.78906 5.99892 7.78613 6.16895C7.78319 6.33898 7.71445 6.50124 7.59437 6.62165C7.47396 6.74174 7.3117 6.81047 7.14167 6.81341C6.97164 6.81635 6.8071 6.75326 6.68262 6.6374C6.52021 6.47448 6.32724 6.34522 6.11478 6.25702C5.90231 6.16882 5.67453 6.12342 5.44449 6.12342C5.21445 6.12342 4.98667 6.16882 4.77421 6.25702C4.56174 6.34522 4.36878 6.47448 4.20637 6.6374L2.01887 8.8249C1.85595 8.98731 1.72669 9.18027 1.63849 9.39274C1.55029 9.6052 1.50489 9.83298 1.50489 10.063C1.50489 10.2931 1.55029 10.5208 1.63849 10.7333C1.72669 10.9458 1.85595 11.1387 2.01887 11.3011Z"
                fill="#B1B2B3"
              />
            </svg>
          </button>
          <button disabled>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="12"
              fill="none"
            >
              <path
                fill="#B1B2B3"
                d="M1.023 11.25a.58.58 0 0 1-.579-.58V1.33a.583.583 0 0 1 .579-.58h10.51c.319 0 .578.26.578.58v9.34a.584.584 0 0 1-.579.58H1.023Zm9.921-3.5V1.917H1.611v8.166L7.444 4.25l3.5 3.5Zm0 1.65-3.5-3.5-4.183 4.183h7.683V9.4Zm-7-3.983a1.167 1.167 0 1 1 0-2.334 1.167 1.167 0 0 1 0 2.334Z"
              />
            </svg>
          </button>
          <button disabled>
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.94466 0.167114C9.16641 0.167114 11.778 2.7787 11.778 6.00045C11.778 9.2222 9.16641 11.8338 5.94466 11.8338C2.72291 11.8338 0.111328 9.2222 0.111328 6.00045C0.111328 2.7787 2.72291 0.167114 5.94466 0.167114ZM5.94466 1.33378C4.70698 1.33378 3.52 1.82545 2.64483 2.70062C1.76966 3.57579 1.27799 4.76277 1.27799 6.00045C1.27799 7.23812 1.76966 8.42511 2.64483 9.30028C3.52 10.1754 4.70698 10.6671 5.94466 10.6671C7.18234 10.6671 8.36932 10.1754 9.24449 9.30028C10.1197 8.42511 10.6113 7.23812 10.6113 6.00045C10.6113 4.76277 10.1197 3.57579 9.24449 2.70062C8.36932 1.82545 7.18234 1.33378 5.94466 1.33378ZM7.57799 7.0837C7.63242 7.0288 7.69721 6.98526 7.76861 6.95562C7.84 6.92597 7.91658 6.91082 7.99389 6.91103C8.07119 6.91125 8.14768 6.92682 8.21892 6.95686C8.29015 6.98689 8.3547 7.03079 8.40882 7.08599C8.46294 7.14119 8.50555 7.2066 8.53417 7.27841C8.56278 7.35023 8.57684 7.42701 8.57553 7.50431C8.57421 7.5816 8.55754 7.65786 8.52649 7.72866C8.49544 7.79945 8.45063 7.86337 8.39466 7.9167C7.74096 8.55881 6.86098 8.91814 5.94466 8.91711C5.02834 8.91814 4.14837 8.55881 3.49466 7.9167C3.38676 7.80785 3.32604 7.66091 3.32561 7.50764C3.32519 7.35437 3.3851 7.2071 3.4924 7.09766C3.5997 6.98821 3.74576 6.92539 3.899 6.92278C4.05225 6.92017 4.20036 6.97797 4.31133 7.0837C4.74697 7.51199 5.33374 7.75152 5.94466 7.75045C6.58049 7.75045 7.15624 7.4967 7.57799 7.0837ZM3.90299 3.66711C4.13506 3.66711 4.35762 3.7593 4.52171 3.9234C4.68581 4.08749 4.77799 4.31005 4.77799 4.54211C4.77799 4.77418 4.68581 4.99674 4.52171 5.16083C4.35762 5.32493 4.13506 5.41711 3.90299 5.41711C3.67093 5.41711 3.44837 5.32493 3.28428 5.16083C3.12018 4.99674 3.02799 4.77418 3.02799 4.54211C3.02799 4.31005 3.12018 4.08749 3.28428 3.9234C3.44837 3.7593 3.67093 3.66711 3.90299 3.66711ZM7.98633 3.66711C8.21839 3.66711 8.44095 3.7593 8.60505 3.9234C8.76914 4.08749 8.86133 4.31005 8.86133 4.54211C8.86133 4.77418 8.76914 4.99674 8.60505 5.16083C8.44095 5.32493 8.21839 5.41711 7.98633 5.41711C7.75426 5.41711 7.5317 5.32493 7.36761 5.16083C7.20352 4.99674 7.11133 4.77418 7.11133 4.54211C7.11133 4.31005 7.20352 4.08749 7.36761 3.9234C7.5317 3.7593 7.75426 3.66711 7.98633 3.66711Z"
                fill="#B1B2B3"
              />
            </svg>
          </button>
        </div>
        <div className="article-options">
          <button
            className="toggle-button-wrapper"
            onClick={() => {
              const searchParams = new URLSearchParams(history.location.search);
              searchParams.delete("edit")
              history.replace(`${history.location.pathname}?${searchParams.toString()}`);
            }}
          >Editing</button>
          <div className="react-speedselect-option">
            <SpeedSelect
              options={STENO_FONT_FAMILY_OPTS}
              displayKey="name"
              uniqueKey="value"
              disableSearch={true}
              disable={true}
            // selectedOption={roleOptions.find(
            //   (option) => option.id === selectedRole
            // )}
            // onSelect={(option) => setSelectedRole(option.id)}
            />
          </div>
          <button disabled>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              fill="none"
            >
              <path
                fill="#B1B2B3"
                d="M10.5 5.25a2.628 2.628 0 0 0 2.625-2.625A2.628 2.628 0 0 0 10.5 0a2.628 2.628 0 0 0-2.625 2.625c0 .196.025.385.066.57L5.124 4.953A2.6 2.6 0 0 0 3.5 4.375 2.628 2.628 0 0 0 .875 7 2.628 2.628 0 0 0 3.5 9.625a2.6 2.6 0 0 0 1.624-.578l2.817 1.76c-.04.184-.066.373-.066.569A2.628 2.628 0 0 0 10.5 14a2.628 2.628 0 0 0 2.625-2.625A2.628 2.628 0 0 0 10.5 8.75c-.616 0-1.175.223-1.624.579l-2.817-1.76A2.64 2.64 0 0 0 6.125 7c0-.196-.025-.385-.066-.567l2.818-1.76a2.598 2.598 0 0 0 1.623.577Zm0-3.5a.876.876 0 0 1 0 1.75.876.876 0 0 1 0-1.75Zm-7 6.125a.876.876 0 1 1 .002-1.751.876.876 0 0 1-.002 1.751Zm7 2.626a.876.876 0 0 1 0 1.75.876.876 0 0 1 0-1.75Z"
              />
            </svg>
          </button>
        </div>
      </div>
      {showColorPicker && (
        <ClickOutsideListner onOutsideClick={() => setShowColorPicker(false)}>
          <SuperSpectrum
            currentColor="#fff"
            onChange={(color) =>
              fnRef.current.setTheColorForSelectedText(color)
            }
            layout="popup"
            hidePopup={() => setShowColorPicker(false)}
          />
        </ClickOutsideListner>
      )}
    </>
  );
}
